import { BDropdownGroup } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

export const EgBDropdownGroup = createEgBootstrapProxy(
  "EgBDropdownGroup",
  BDropdownGroup
);
